import React, {Component} from 'react'
import axios from 'axios'
import { fabric } from 'fabric';
import CountUp from "react-countup";
import * as _ from 'lodash-joins'
import CS from '../../../commons/services/Common'
import MS from '../../../commons/services/Moment'
import AS from '../../Login/Service/Authentication'
import PS from '../../PlantList/MonitoringApiService'
import TransformModules from './TransformModules'

var SCALE_FACTOR = 1;
var TEMPLATE_WIDTH = 600;
var TEMPLATE_HEIGHT = 500;

class IssueDetail extends Component {

    constructor(props) {
        super(props)
        this.state = {
            batchType: "row",
            plantId: props.match.params.plantId,
            moduleInfos: [],
            inverterSerialNos: [],
            moduleSerialNos: [],
            plantInfo: {},
            cst: {},
            inverters: [],
            isLoading: false,
            currentTitle: null,
            issues: [],
            issueReason: '',
            issueId: '',
            
            receivedTime: null,
            increament: 0,
            inputPower: 0,
            inputVoltage: 0,
            inputCurrent: 0,
            outputPower: 0,
            outputVoltage: 0,
            outputCurrent: 0,
            activeInverterSerialNo: '',
            joinResultGroup: [],
        }
        this.statusInfos = [];
        this.endingIssue = this.endingIssue.bind(this);
    }


    componentDidMount = () => {
        this.buildCanvas();
        this.getPlantInfo();
        this.getModuleInfos();
        this.getIssue();
        this.interval = setInterval(() => {
            //this.getPlantInfo();
            this.getRealtimePower(this.state.inverterSerialNos);
            this.getModuleStatus();
        }, 10000*1 * 6);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    buildCanvas() {
        this.canvas = this.__canvas = new fabric.Canvas('c', {
            //backgroundImage: '/images/test.jpg'
        });
        //this.canvas.setHeight(document.body.scrollHeight);
        this.canvas.selection = false;
    }

    getPlantInfo = async() => {
        const {plantId} = this.state;
        let {plantInfo, inverterSerialNos} = this.state;
        if (inverterSerialNos.length == 0) {
            const res = await axios.get(`/usr/api/user-plant/info?plantIds=${plantId}`);
            plantInfo = res.data[0];
            const costructorId = plantInfo.constructorId;
            const plantInfos = AS.getLoggedInPlantInfos();
            let filteredPlantInfo = plantInfos.filter(v => v.id == plantId);
            inverterSerialNos = CS.getKeyValues(filteredPlantInfo[0].invs, "serialNo");
            plantInfo.invs = filteredPlantInfo;
            plantInfo.operationStartDt = MS.format(plantInfo.operationStartDt, "YYYY년 M월 D일");
            let cst = await axios.get(`/cst/api/constructor/${costructorId}`);

            this.setState({
                inverterSerialNos: inverterSerialNos,
                plantInfo: plantInfo,
                cst: cst.data
            });
            this.getRealtimePower(inverterSerialNos);
        }
    }

    

    getModuleInfos = async () => {
        const {plantId} = this.state;
        await axios.get(`/cst/api/constructor-plant/equipment/${plantId}`)
        .then(res => {
            
            let moduleInfos = [];
            let modulesGroupbyString = [];
            let zigbees = [];
            res.data.some(v1 => {
                const strings = JSON.parse(v1.stringInfo);
                let modules;
                strings.some(v2 => {
                    modules = v2.children;
                    this.buildModules(v1.inverterNo, modules);
                    modulesGroupbyString.push({
                        stringId: v2.title,
                        modules: modules
                    });
                    moduleInfos = [
                        ...moduleInfos,
                        ...modules
                    ]
                    zigbees = [
                        ...zigbees,
                        ...CS.getKeyValues(modules, "zigbee")
                    ];
                })
            });
            this.setState({
                moduleInfos: moduleInfos,
                modulesGroupbyString: modulesGroupbyString,
                moduleSerialNos: zigbees
            })
            this.getModuleStatus();
            //this.connectLine(modulesGroupbyString)
        })
        .catch((error) => {
            console.error("Fetch Error getModuleInfo: ", error)
        });
    }

    connectLine = (stringId) => {
        const {modulesGroupbyString} = this.state;
        const idx = modulesGroupbyString.findIndex((e) => {
            return e.stringId == stringId;
        });
        if (idx > -1) {
            const canvasData = this.canvas._objects;
            const strIdx = canvasData.findIndex((e) => {
                return e.type == "string" && e.title == stringId;
            });
            if (strIdx > -1) {
                canvasData.splice(strIdx, 1);
                this.canvas.renderAll();
            } else {
                let datas = modulesGroupbyString[idx].modules;
                datas = datas.sort((a, b) => {
                    let aT = parseInt(a.title.split(".")[2]);
                    let bT = parseInt(b.title.split(".")[2]);
                    return aT - bT;
                });
                let grp1, grpIdx1, grp2, grpIdx2, connector;
                const connectors = [];
                for (let i = 0; i < datas.length - 1; i++) {
                    grpIdx1 = canvasData.findIndex((e) => {
                        return e.title == datas[i].title;
                    });
                    grpIdx2 = canvasData.findIndex((e) => {
                        return e.title == datas[i+1].title;
                    });
                    grp1 = canvasData[grpIdx1].getPointByOrigin('center');
                    grp2 = canvasData[grpIdx2].getPointByOrigin('center');
                    connector = new fabric.Line(
                        [grp1.x, grp1.y, grp2.x, grp2.y], {
                            stroke: '#0000C9',
                            strokeWidth: 2,
                            strokeDashArray: [3, 5],
                            lockScalingX: true,
                            lockScalingY: true,
                            lockRotation: false,
                            hasControls: false,
                            hasBorders: false,
                            lockMovementX: true,
                            lockMovementY: true
                        }
                    )
                    connectors.push(connector);
                }
                const lineGroup = new fabric.Group(connectors, {
                    type: "string",
                    title: stringId,
                    hasControls: false,
                    draggable: false
                });
                this.canvas.add(lineGroup)
            }
        }
    }

    buildModules = (inverterNo, modules) => {
        let rect, text, group, canvasInfo;
        modules.some( (v, idx) => {
            rect = new fabric.Rect({
                width: 15,
                height: 30,
                fill: '#FFFFFF'
            });
            text = new fabric.Text(v.title, {
                visible: false,
                fontSize: 0
            });
            canvasInfo = v.canvasInfo;

            group = new fabric.Group([ rect, text ], {
                type: "module",
                title: v.title,
                zigbee: v.zigbee,
                inverterNo: inverterNo,
                left: canvasInfo.leftX,
                top: canvasInfo.topY,
                lockMovementX: true,
                lockMovementY: true,
                angle: v.azimuth,
                hasControls: false,
                draggable: false
            });

            this.canvas.add(group);
            group.on("mouseover", function(e) {
                popover(true, e, this.title, this.zigbee);
            });
            group.on("mouseout", function(e) {
                popover(false, e, "", "");
            });
            const popover = (isShow, e, title, zigbee) => {
                let receivedTime;
                let inputCurrent = 0;
                let inputVoltage = 0;
                let inputPower = 0;
                let outputCurrent = 0;
                let outputVoltage = 0
                let outputPower = 0;
    
                if (isShow) {
                    this.statusInfos.some(v => {
                        if (v._id == zigbee) {
                            //let power = v.power;
                            receivedTime = v.time;
                            inputCurrent = Math.abs(v.inputCurrent*-1);
                            inputVoltage = Math.abs(v.inputVoltage);
                            inputPower = Math.abs(v.inputPower*-1);
                            outputCurrent = Math.abs(v.outputCurrent*-1);
                            outputVoltage = Math.abs(v.outputVoltage);
                            outputPower = Math.abs(v.outputPower*-1);
                            return true;
                        }
                    });
                    this.setState({
                        currentTitle: title,
                        receivedTime: receivedTime, 
                        inputPower: inputPower,
                        inputVoltage: inputVoltage,
                        inputCurrent: inputCurrent,
                        outputPower: outputPower,
                        outputVoltage: outputVoltage,
                        outputCurrent: outputCurrent
                    })
                }
            }
        });
    }

    async getModuleStatus() {
        try {
            const {moduleInfos} = this.state;
            const param = {
                "moduleSerialNos": this.state.moduleSerialNos
            }
    
            let status = await PS.getLatestModuleList(param, this.state.plantId);
            
            const joinResult = _.sortedMergeLeftOuterJoin(moduleInfos, "zigbee", status, "_id");
            
            this.joinModulesData(joinResult)
            this.statusInfos = status;
    
            let outputPowerAvg = 0;
            if (status.length > 0) {
                let limitSize = Math.floor(status.length *0.2);
                limitSize = limitSize == 0 ? 1 : limitSize;
                let outputPowers = CS.getKeyValues(status, 'outputPower');
                outputPowers.sort((a,b)=>b-a);
                // outputPowers = CS.sortDesc(outputPowers.map(v => { return v*-1 }));
                outputPowerAvg = CS.calcSplitArrayAvg(outputPowers, 0, limitSize)
            }
    
            let inputCurrentArr = [];
            status.some( v => {
                inputCurrentArr.push(Math.abs(v.inputCurrent*-1));
            });
            let minInputCurrent = Math.min.apply(null, inputCurrentArr);
    
            let increament = 0;
            status.some( v => {
                // increament = increament + ( (v.outputPower*-1) - (v.inputVoltage * minInputCurrent));
                increament = increament + ( (v.outputPower) - (v.inputVoltage * minInputCurrent));
            });
    
            this.setState({
                increament: (increament/1000).toFixed(2)
            });
    
            let color;
            this.canvas._objects.some(v => {
                if (v.type == "module") {
                    color = "#1c1c1c";
                    const index = status.findIndex((e) => {
                        return e._id === v.zigbee;
                    });
                    if (index >= 0) {
                        // const rate = Math.round(( (status[index].outputPower*-1)/outputPowerAvg ) * 100);
                        const rate = Math.round(( (status[index].outputPower)/outputPowerAvg ) * 100);
                        if (rate >= 75) {
                            color = "#ff65cc";
                        } else if (rate >= 50 && rate < 75) {
                            color = "#d63bff";
                        } else if (rate >= 25 && rate < 50) {
                            color = "#a55bff";
                        } else {
                            color = "#5d129f";
                        }
                    }
                    v._objects[0].set('fill', color);
                }
            });
            this.canvas.renderAll();
        } catch (error) {
            console.error("canvas error: ", error);
        }
    }

    joinModulesData = (joinResult) => {
        joinResult.some( (v,i) => {
            if (v._id !== undefined) {
                joinResult[i].status = (v.inputPower * -1 < 0 || v.outputPower * -1 < 0) ? "state-error" : "stage-on";
            } else {
                joinResult[i].status = "state-off";
                joinResult[i].inputCurrent = 0;
                joinResult[i].inputVoltage = 0;
                joinResult[i].inputPower = 0;
                joinResult[i].outputCurrent = 0;
                joinResult[i].outputVoltage = 0;
                joinResult[i].outputPower = 0;
            }
            //joinResult[i].isLowerThanAvg = (v.powerStageTemp < avgs[`avg` + avgIdx]);
        });
        
        const joinResultGroup = _.chain(joinResult)
            .groupBy(v => {
                let titleArr = v.title.split(".");
                return `${titleArr[0]}.${titleArr[1]}`
            })
            .map(
                (modules, stringId) => ({
                    stringId: stringId,
                    inverterIdx: stringId.split(".")[0],
                    stringIdx: stringId.split(".")[1],
                    modules: modules.sort((a, b) => {
                        let aT = parseInt(a.title.split(".")[2]);
                        let bT = parseInt(b.title.split(".")[2]);
                        return aT - bT;
                    })
                })
            )
            .orderBy(
                ['inverterIdx, stringIdx'], ['asc']
            )
            .value();

        
        this.setState({
            joinResultGroup: joinResultGroup
        });
    }

    getRealtimePower = async(inverterSerialNos) => {
        const param = {
            "inverterSerialNos": inverterSerialNos
        }
        const inverters = await PS.getLatestInverter(param);
        this.settingInverterData(inverters);
    }

    settingInverterData = (list) => {
        const inverters = [];
        let totalPvCurrent = 0, totalRCurrent = 0, totalSCurrent = 0, totalTCurrent = 0, totalAccumulationPower = 0;
        list.some((v, i) => {
            totalPvCurrent += v.pvCurrent;
            totalRCurrent += v.lineRCurrent;
            totalSCurrent += v.lineSCurrent;
            totalTCurrent += v.lineTCurrent;
        });
        /*
        if (list.length > 1) {
            inverters.push(
                {
                  _id: "",
                  pvCurrent: totalPvCurrent,
                  rCurrent: totalRCurrent,
                  sCurrent: totalSCurrent,
                  tCurrent: totalTCurrent,
                }
            );
        }
        */
        inverters.push(...list);
        this.setState({
            inverters: inverters
        });
    }
    

    async getIssue() {
        let res = await axios.get(`/cst/api/plant-issue/detail/${this.state.plantId}/1`);
        this.setState({
            issues: res.data
        })
    }

    issueClick(issueId) {
        let re = this.state.issues.filter((item) => item.id === issueId);
        this.setState({
            issueId: re[0].id,
            issueReason: re[0].faultCode,
        });
    }

    async endingIssue() {
        let param = {
            id: CS.$("#issueId"),
            solution: CS.$("#solution")
        }
        let result = await CS.customCreate(`/cst/api/plant-issue/ending`, param, '해당 이슈를 종료하시겠습니까?');
        if(result.isSuccess)
            this.getIssue();
    }

    zoomInAndOut = (val) => {
        SCALE_FACTOR = Number(SCALE_FACTOR) + val;
        SCALE_FACTOR = Number(SCALE_FACTOR).toFixed(1);
        let tmWidth = TEMPLATE_WIDTH * SCALE_FACTOR;
        let tmHeight = TEMPLATE_HEIGHT * SCALE_FACTOR;
        this.canvas.setZoom(SCALE_FACTOR);
        this.canvas.calcOffset();
        this.canvas.renderAll();
    }

    handleActiveModulesByInverter = (id) => {
        this.setState({
            activeInverterSerialNo: id
        })
        this.canvas._objects.some(v => {
            v._objects[0].group.visible = id === "" || (v.inverterNo === id);
        });
        this.canvas.renderAll();
    }

    handleClickModule = (title, zigbee) => {
        // console.log(title, zigbee)
        this.canvas._objects.some(v => {
            if (v.type == "module" && v.title == title) {
                const obj = v._objects[0];
                obj.set('stroke', obj.stroke == null ? '#009300' : null);
                return true;
            }
        });
        const stringId = `${title.split(".")[0]}.${title.split(".")[1]}`
        this.connectLine(stringId);
        this.canvas.renderAll();
    }

    
    render() {
        const {
            isLoading,
            plantInfo, cst, issues, issueReason, issueId, inverters, moduleSerialNos, joinResultGroup,
            currentTitle, receivedTime, inputPower, inputVoltage, inputCurrent, outputPower, outputVoltage, outputCurrent, increament,
            activeInverterSerialNo
        } = this.state;
        
        return (
            <>
                <section className="bg-gray pt-25 pb-45 current-issue">
                    <div className="container">
                        <div className="card navy info">
                            <div className="h-stack">
                                <div>
                                    <h2 className="name">{plantInfo.name}</h2>
                                    <p className="addr">{plantInfo.address}</p>
                                    <br/>
                                    <div className="counter">
                                        <strong className="tit">설비용량</strong>
                                        <strong className="num">&nbsp;{(plantInfo.installationCapacity)}</strong><strong className="unit">kW</strong>
                                    </div>
                                </div>
                                <div className="wp15">
                                    <h3 className="tit">시공사 명</h3>
                                    <p className="txt">{cst.constructorName}</p>
                                </div>
                                <div className="wp20">
                                    <h3 className="tit">시공사 연락처</h3>
                                    <p className="txt">{cst.contactNum}</p>
                                </div>
                            </div>
                        </div>

                        <div className="num-value">
                            <div className="card line graph">
                                <div className="x-bar">
                                    <div className="tit">
                                        <div>상위 25%</div>
                                        <div>상위 50%</div>
                                        <div>상위 75%</div>
                                        <div>하위 25%</div>
                                        <div style={{width: "15%"}}>작동안함</div>
                                    </div>
                                    <div className="bar">
                                        <div style={{backgroundColor: "#ff65cc"}}></div>
                                        <div style={{backgroundColor: "#d63bff"}}></div>
                                        <div style={{backgroundColor: "#a55bff"}}></div>
                                        <div style={{backgroundColor: "#5d129f"}}></div>
                                        <div style={{backgroundColor: "#1c1c1c", width: "15%"}}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="card4 t-info">
                                <div className="f-stack">
                                    <div className="item">
                                        <div className="title">제어 전</div>
                                        <div className="text">
                                            <div>
                                                <span className="tit">입력전력(W)</span>
                                                <span className="num" id="inputPower"><CountUp end={inputPower} decimals={1} duration={0.2} /></span>
                                            </div>
                                            <div>
                                                <span className="tit">입력전압(Vdc)</span>
                                                <span className="num" id="inputVoltage"><CountUp end={inputVoltage} decimals={1} duration={0.2} /></span>
                                            </div>
                                            <div>
                                                <span className="tit">입력전류(A)</span>
                                                <span className="num" id="inputCurrent"><CountUp end={inputCurrent} decimals={1} duration={0.2} /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="title">제어 후</div>
                                        <div className="text">
                                            <div>
                                                <span className="tit">출력전력(W)</span>
                                                <span className="num" id="outputPower"><CountUp end={outputPower} decimals={1} duration={0.2} /></span>
                                            </div>
                                            <div>
                                                <span className="tit">출력전압(Vdc)</span>
                                                <span className="num" id="outputVoltage"><CountUp end={outputVoltage} decimals={1} duration={0.2} /></span>
                                            </div>
                                            <div>
                                                <span className="tit">출력전류(A)</span>
                                                <span className="num" id="outputCurrent"><CountUp end={outputCurrent} decimals={1} duration={0.2} /></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex inc-power">
                                    <strong>
                                    {
                                        currentTitle
                                        ?   <>
                                            모듈<a onClick={() => this.connectLine(`${currentTitle.split(".")[0]}.${currentTitle.split(".")[1]}`)}>({currentTitle})</a> 수신시각&nbsp;
                                            : <i>{receivedTime ? receivedTime : "미수신"}</i>
                                            </>
                                        :   <></>
                                    }
                                    </strong>
                                    <span>
                                        발전량&nbsp;&nbsp;<i><b><font color="red">{increament}</font></b> kW</i>&nbsp;&nbsp;증가
                                    </span>
                                    {/*<BootstrapSwitchButton checked={true} />*/}
                                </div>
                                {/*
                                <div className="flex inc-power">
                                    <strong>ON-OFF</strong>
                                    <span>
                                    </span>
                                </div>
                                */}
                            </div>
                        </div>

                        {/*임시
                            this.state.plantId == 26 &&
                            <>
                            <div className="card2">
                                <div className="f-stack form-view">
                                    <div>
                                        <h2>제어모델관리</h2>
                                    </div>
                                    <div>
                                        <span className="tit">발전저하모델 :</span>
                                        <strong>PD_026_N</strong>
                                    </div>
                                    <div>
                                        <span className="tit">제어모델 :</span>
                                        <strong>CT_026_N</strong>
                                    </div>
                                    <div><span className="tit"></span><strong></strong></div>
                                    <div><span className="tit"></span><strong></strong></div>
                                    <div><span className="tit"></span><strong></strong></div>
                                    <div><span className="tit"></span><strong></strong></div>
                                </div>
                            </div>
                            <br/>
                            </>
                        */}

                        <div className="card m-map h450" style={{overflow: "scroll", zIndex:0}}>
                            <div className="control-btn">
                                <button type="button" onClick={() => this.zoomInAndOut(0.1)}>
                                    <img src="/images/ctors/map/zoom-in.png" alt="확대" />
                                </button>
                                <button type="button">
                                    <img src="/images/ctors/map/zoom-reset.png" alt="초기화" />
                                </button>
                                <button type="button" onClick={() => this.zoomInAndOut(-0.1)}>
                                    <img src="/images/ctors/map/zoom-out.png" alt="축소" />
                                </button>
                            </div>
                            <canvas id="c" width="1000" height="1000"></canvas>
                        </div>
                        <div className="card">
                            <TransformModules
                                joinResultGroup={joinResultGroup} isLoading={isLoading}
                                handleClickModule={(title, zigbee) => this.handleClickModule(title, zigbee)}
                            />
                        </div>
                        <div className="card py-30">
                            <h3 className="content-tit1 mt-0">
                                인버터별 실시간 출력
                                {
                                    inverters.length > 1 &&
                                    <>&nbsp;(<a onClick={() => this.handleActiveModulesByInverter('')}>전체보기</a>)</>
                                }
                            </h3>
                            <div className="inverter-s1-wrapper">
                                {
                                    inverters.map((row, index) => (
                                        <div className={row._id == activeInverterSerialNo ? 'inverter-s1 active' : 'inverter-s1'} key={index}>
                                            <div className="title">
                                                <p className="icon"><img src="/images/ctors/icon/inverter.png" alt="" /></p>
                                                {/*<p className="tit">{`인버터${index+1}`}</p>*/}
                                                <p className="tit"><a onClick={() => this.handleActiveModulesByInverter(row._id)}>{`인버터${index+1}`}</a></p>
                                            </div>
                                            <div className="text">
                                                <div className="form-inline2">
                                                    <div className="form-group">
                                                        <label className="tit">DC 전압</label>
                                                        <input type="text" defaultValue={row.pvVolt} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">DC 전류</label>
                                                        <input type="text" defaultValue={row.pvCurrent} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">DC 출력</label>
                                                        <input type="text" defaultValue={PS.formatNumber((row.pvCurrent * row.pvVolt) / 1000)} readOnly/>
                                                    </div>
                                                </div>
                                                <div className="form-inline2">
                                                    <div className="form-group">
                                                        <label className="tit">R상 전압</label>
                                                        <input type="text" defaultValue={row.lineRVolt} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">R상 전류</label>
                                                        <input type="text" defaultValue={row.lineRCurrent} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">R상 출력</label>
                                                        <input type="text" defaultValue={PS.formatNumber((row.lineRCurrent * row.lineRVolt / Math.sqrt(3)) / 1000)} readOnly/>
                                                    </div>
                                                </div>
                                                <div className="form-inline2">
                                                    <div className="form-group">
                                                        <label className="tit">S상 전압</label>
                                                        <input type="text" defaultValue={row.lineSVolt} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">S상 전류</label>
                                                        <input type="text" defaultValue={row.lineSCurrent} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">S상 출력</label>
                                                        <input type="text" defaultValue={PS.formatNumber((row.lineSCurrent * row.lineSVolt / Math.sqrt(3)) / 1000)} readOnly/>
                                                    </div>
                                                </div>
                                                <div className="form-inline2">
                                                    <div className="form-group">
                                                        <label className="tit">T상 전압</label>
                                                        <input type="text" defaultValue={row.lineTVolt} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">T상 전류</label>
                                                        <input type="text" defaultValue={row.lineTCurrent} readOnly/>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="tit">T상 출력</label>
                                                        <input type="text" defaultValue={PS.formatNumber((row.lineTCurrent * row.lineTVolt / Math.sqrt(3)) / 1000)} readOnly/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="card">
                            <div className="past-list view">
                                <div className="group">
                                    <div className="top">
                                        <div className="tit">이슈정보</div>
                                    </div>
                                    <div className="module">
                                        <span className="tit">이슈목록</span>
                                        <div className="inline">
                                            {
                                                issues.map((row, index) => (
                                                    <label className="white-label" key={index} onClick={() => this.issueClick(row.id)}>
                                                        {row.faultCode}
                                                    </label>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className="memo">
                                        <input type="hidden" id="issueId" defaultValue={issueId} />
                                        <div>
                                            <div className="h-stack">
                                                <div className="tit w40">원인</div>
                                                <div className="txt bold">
                                                    <input type="text" className="wp100 line0" defaultValue={issueReason} placeholder="내용입력" />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="h-stack">
                                                <div className="tit w40">해결</div>
                                                <div className="txt bold">
                                                    <input type="text" className="wp100 line0" id="solution" placeholder="내용입력" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-areaC2 mt-15">
                                <button type="button" className="btn primary" onClick={this.endingIssue}>저장 후 이슈종료</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <h3 className="content-tit1">기본 정보</h3>
                        <div className="card2">
                            <div className="f-stack form-view">
                                <div className="wp50">
                                    <span className="tit">운전 개시일</span>
                                    <strong>{plantInfo.operationStartDt}</strong>
                                    <small className="size13 ml-10">{plantInfo.diff}</small>
                                </div>
                                <div className="wp50">
                                    <span className="tit">사업주 명</span>
                                    <strong>{plantInfo.ownerName}</strong>
                                </div>
                            </div>
                        </div>

                        <h3 className="content-tit1">태양광 정보</h3>
                        <div className="card2">
                            <table className="style1">
                                <colgroup>
                                    <col style={{width: "16%"}}/>
                                    <col />
                                    <col style={{width: "18%"}}/>
                                    <col style={{width: "14%"}}/>
                                    <col style={{width: "14%"}}/>
                                    <col style={{width: "18%"}}/>
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th className="left">태양광 모듈 &gt;</th>
                                        <td>{plantInfo.moduleCorpName}</td>
                                        <td>{plantInfo.moduleModelName}</td>
                                        <td>{moduleSerialNos.length} 장</td>
                                        <td>{plantInfo.installationCapacity} W</td>
                                        <td>{plantInfo.moduleCorpPhone}</td>
                                    </tr>
                                    <tr>
                                        <th className="left">인버터 &gt;</th>
                                        <td>{plantInfo.inverterCorpName}</td>
                                        <td>{plantInfo.inverterModelName}</td>
                                        <td>{inverters.length}대</td>
                                        <td></td>
                                        <td>{plantInfo.inverterCorpPhone}</td>
                                    </tr>
                                    <tr>
                                        <th className="left">구조물 &gt;</th>
                                        <td>{plantInfo.structureName}</td>
                                        <td>용용아연 철</td>
                                        <td></td>
                                        <td></td>
                                        <td>{plantInfo.structureBizTelNum}</td>
                                    </tr>
                                    <tr>
                                        <th className="left">전기 공사 &gt;</th>
                                        <td>{plantInfo.electricWorkBizName}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{plantInfo.electricWorkBizTelNum}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default IssueDetail

